import {validate as validator} from "validate.js";

const rules = () => {
    return {
        name: {
            presence: true,
            length: {
                minimum: 2,
            }
        },
    }
};

const validate = (language) => {
    return validator(language, rules())
};

export default {validate};
